import { generatePath } from 'react-router-dom'
import { BRAIN_PLAYGROUND_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Brainstorm } from 'blaze-ui/icons/24'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuBrainPlaygroundItem = ({ workspaceId, onPress }: Props) => {
  return (
    <NavMenuItem
      icon={Brainstorm}
      activeIcon={Brainstorm}
      to={generatePath(BRAIN_PLAYGROUND_PATH, { workspaceId })}
      onPress={onPress}
      label="Brain Playground"
    />
  )
}

export { NavMenuBrainPlaygroundItem }
